import { UCMapEvent } from "../UCMapJs";
import { POISurroundType, POISurroundInfo, POIResultItem } from "../../model/POISearch";

/*
 * @Author: your name
 * @Date: 2020-01-09 14:04:58
 * @LastEditTime : 2020-01-09 17:09:41
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \source\src\components\onlineMap\mainMap\UCOverlay\MapRightHandButtonOverlayJs.js
 */
export class MapRightHandButtonOverlayJs {
    constructor() {
        this.id_li_poi_near = "id_li_poi_near";

        this.id_li_route_start_point = "id_li_route_start_point";

        this.id_li_route_via_point = "id_li_route_via_point";

        this.id_li_route_end_point = "id_li_route_end_point";

        this.ucOverLay = null;

        this.mapInfo = null;

        this.surroundInfo = null;

    }


    init() {

        this.surroundInfo=new POISurroundInfo();

        let poi=new POIResultItem();
        poi.x=this.mapInfo.overlayPoint[0];
        poi.y=this.mapInfo.overlayPoint[1];
        this.surroundInfo.poi=poi;
        
    }

    bindingEvents() {
        this._bindingDomElementEvents();
    }

    on_getPOIInfoFinished(callback) {
        if (callback) {
          this.ucOverLay.$on(
            UCMapEvent.MapRightHandButtonOverlay_event_getPOIInfoFinished,
            callback
          );
        }
      }

    

    ucRenderFinished(callback) {
        let self = this;
        this.ucOverLay.$nextTick(function () {

            let innerHtml = self.ucOverLay.$el.innerHTML;
            if (callback) {
                callback(innerHtml);
            }
        });


    }


    _bindingDomElementEvents() {
        let self = this;
        
        let elePoiNear = document.getElementById(this.id_li_poi_near);
        elePoiNear.onclick = function () {

            self.surroundInfo.surroundType = POISurroundType.type_POI;
            self._getPOIInfoFinishedHandler();

        };

        let eleStartPoint = document.getElementById(this.id_li_route_start_point);
        eleStartPoint.onclick = function () {

            self.surroundInfo.surroundType = POISurroundType.type_route_startPOI;
            self._getPOIInfoFinishedHandler();

        };

        let eleViaPoint = document.getElementById(this.id_li_route_via_point);
        eleViaPoint.onclick = function () {
            
            self.surroundInfo.surroundType = POISurroundType.type_route_viaPOI;
            self._getPOIInfoFinishedHandler();
        };

        let eleEndPoint = document.getElementById(this.id_li_route_end_point);
        eleEndPoint.onclick = function () {

            self.surroundInfo.surroundType = POISurroundType.type_route_endPOI;
            self._getPOIInfoFinishedHandler();

        };

    }


    _getPOIInfoFinishedHandler()
    {   
        this.ucOverLay.$emit(
            UCMapEvent.MapRightHandButtonOverlay_event_getPOIInfoFinished,
            this.surroundInfo
          );
          
    }


}

export const MapRightHandButtonOverlayEvents =
{





}
